/**
 * Configuración de la API para desarrollo y producción
 */

/**
 * Obtiene la URL base de la API según el entorno
 * En desarrollo: usa localhost:5000
 * En producción: usa rutas relativas (mismo dominio)
 */
export const getApiBaseUrl = (): string => {
  return process.env.REACT_APP_API_URL || 
    (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5000');
};

/**
 * URL base de la API
 */
export const API_BASE_URL = getApiBaseUrl();

// Log para debugging
console.log('🔧 API Configuration:', {
  API_BASE_URL,
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_API_URL: process.env.REACT_APP_API_URL
});